import { render, staticRenderFns } from "./SelectExtraModuleModal.vue?vue&type=template&id=bf8cf0b4&"
import script from "./SelectExtraModuleModal.vue?vue&type=script&lang=js&"
export * from "./SelectExtraModuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports